import { Skeleton } from '@/components/ui/skeleton';

export const ShowtimeSkeletonComponent = (): React.JSX.Element => {
  return <Skeleton className="h-8 w-full min-w-[100px]" />;
};
